export default "__VITE_ASSET__BWXlyXb2__"